//@flow
import {useSelector} from 'react-redux';

import type {RootState} from '../../../modules';
import {actions} from '../../dashboard/duck';
import {useActions} from '../../../utils/globalStore';

const completedConfigSelector = (state: RootState) =>
  state.dashboard.completedConfig;

const logoSelector = (state: RootState) =>
  state.ui.storeInformation && state.ui.storeInformation.logoId;

const productCountSelector = (state: RootState) =>
  state.dashboard.productsCount;

const pageDisplayedSelector = (state: RootState) =>
  state.dashboard.pageDisplayed;

const categoryCountSelector = (state: RootState) =>
  state.categories.categories ? state.categories.categories.length : undefined;

export function useMissingRequiredSteps() {
  const logoId = useSelector(logoSelector);
  const productCount = useSelector(productCountSelector);
  const pageDisplayed = useSelector(pageDisplayedSelector);
  const completedConfig = useSelector(completedConfigSelector);

  const setPageDisplayed = useActions(actions.setPageDisplayed);

  /*   const hasPaymentMethods =
    paymentMethods &&
    paymentMethods
      .filter(pm => pm.paymentMethod !== 'CONTINUE_TO_CHAT')
      .filter(pm => pm.enabled).length;
 */

  return {
    logo: !!logoId || completedConfig,
    products: !!productCount || completedConfig,
    pageDisplayed: !!pageDisplayed || completedConfig,
    setPageDisplayed,
  };
}

export function useMissingOptionalSteps() {
  const categoriesCount = useSelector(categoryCountSelector);

  return {
    categories: categoriesCount !== 0,
  };
}

export function useOnboardingProgress() {
  const {logo, products, pageDisplayed} = useMissingRequiredSteps();

  const progressPercentage = Math.round(
    ((logo + products + pageDisplayed) / 3) * 100
  );

  return progressPercentage;
}
